import React, { useEffect, useState } from 'react';

import { getMenuLinks } from 'helpers/get-menu-links';
import { DesktopMenu, DeviceMenu, LinkLogo } from 'components/Navigation';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  const menu = getMenuLinks();
  const scrolledClassName = scrolled ? 'sticky' : 'static';

  useEffect(() => {
    const handleScroll = () => {
      const headerInner = document.getElementById('header-inner');
      const headerInnerTopFallback = 40;
      let headerInnerTop;

      if (headerInner) {
        headerInnerTop = headerInner.offsetTop;
      } else {
        headerInnerTop = headerInnerTopFallback;
      }

      const isScrolled = window.scrollY > headerInnerTop;

      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };

    handleScroll();

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header className={`header talenteer-header ${scrolledClassName}`}>
      <div className="container">
        <div id="header-inner" className="header-inner">
          <LinkLogo linkClass="desktop-menu-only" />
          <DesktopMenu menu={menu} />
          <DeviceMenu menu={menu} />
        </div>
      </div>
    </header>
  );
};
